import React, { Component } from "react";
import EmployeesNoveltiesForm from "../EmployeesNoveltiesForm/EmployeesNoveltiesForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : EmployeesNoveltiesPage
Description : Componente que invoca al componente EmployeesNoveltiesForm
Date Autor Modification
================================================================================
14/04/2026 scoca – Creacióm
================================================================================ */
class EmployeesNoveltiesPage extends Component {
    render() {
        return (
            <EmployeesNoveltiesForm />
        )
    }
}

export default EmployeesNoveltiesPage;